<template>
  <div class="home">
    <app-header>
      <h1>Stéphanie Lefebvre</h1>
      <h2>Shiatsu – Reiki – Réflexologie – LaHoChi - Massage des 5 Continents </h2>
    </app-header>
    <div class="content">
      <h4>Douleurs, tensions, stress, angoisse, fatigue, troubles du sommeil, déprime... </h4>
      <h4 class="custom">Avez-vous pensé aux méthodes de soins naturelles ?</h4>
      <article>
        <img src="~@/assets/background/left-flower.png" alt="flower" class="flower left">
        <div class="bloc">
          <h1>Je me présente ...</h1>
          <p>
            Enfant, je prenais soin des oisillons tombés du nid, les entourant de mes mains pour leur redonner de la
            force et de la chaleur... Je dessinais, je vibrais devant les instruments de musique, devant la beauté de la
            nature et de ses animaux... Je massais aussi ma grand-mère qui adorait mes massages... Je voulais être
            médecin, vétérinaire, kiné, sage-femme... Bref, <span>je voulais prendre soin des êtres qui m'entouraient...</span>
          </p>

          <p>
            J'ai exercé, avec une immense joie, de nombreuses années, dans le domaine de la musique ainsi que dans
            l'accompagnement des enfants en situation de handicap, et dans le même temps, la vie m'a offert de découvrir
            une merveille : <span>le Reiki.</span>
          </p>
        </div>
        <img src="~@/assets/background/right-flower.png" alt="flower" class="flower right">
        <div class="bloc">
          <p>
            Cela a été le début d'un <span>magnifique cheminement intérieur</span> qui m'a emmenée ensuite vers <span>la Réflexologie
            plantaire, le Shiatsu, le LaHoChi et enfin, vers le Massage des 5 Continents</span>, qui est pour moi une véritable
            révélation et une reconnexion à ce qui vibrait en moi depuis toujours : <span>prendre soin des autres avec mes
            mains.</span>
          </p>
          <p>
            C'est avec un immense plaisir et un profond respect de votre être et de votre intimité que je souhaite vous
            accompagner, au travers de ces soins, dans votre évolution personnelle.
          </p>

          <p>
            Les séances se déroulent au sein de mon cabinet situé au 26 bis rue Sèche 62400 Essars et se font uniquement
            sur rendez-vous.
          </p>
          <router-link to="/contact">
            <button>Me contacter</button>
          </router-link>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header'

export default {
  name: 'Home',
  components: { AppHeader }
}
</script>

<style lang="scss" scoped>
//TODO TEMP
@import url('https://fonts.googleapis.com/css?family=Cedarville+Cursive|Delius|Sacramento&display=swap');

.home {
  display: flex;
  flex-direction: column;
  flex: 1;

  .content {
    position: relative;
    text-align: center;
    background-color: #f1fae7;
    align-items: center;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media screen and (max-width: 680px) {
      overflow: auto;
    }

    button {
      outline: none;
      border-radius: 8px;
      padding: 1em;
      border: 2px solid $color-red;
      color: $color-red;
      text-transform: uppercase;
      font-weight: 500;
      cursor: pointer;
      font-size: 1.1em;
      transition: .25s ease all;
      background: none;
      margin-top: 2em;
      width: 100%;
      box-sizing: border-box;

      &:hover {
        box-shadow: inset 0 0 0 2em $color-red;
        color: #fff;
      }
    }

    h4 {
      width: 50%;
      margin: .5em;
      font-weight: 300;
      font-size: 1.1em;
      font-family: 'Delius', cursive;

      &.custom {
        border-bottom: 2px solid $color-green;
        padding-bottom: 1em;
        font-weight: 700;
      }
    }

    article {
      @include custom-article();

      img {
        position: absolute;
        z-index: 0;
        opacity: .5;

        &.left {
          bottom: -7vw;
          left: 4vw;
        }

        &.right {
          top: 0;
          right: 4vw;
        }
      }
    }
  }
}
</style>
